import { DocPage } from "../components/DocPage";

export const ssr = { mode: "ssg" as const };

export default function Seo() {
  return (
    <DocPage
      title="SEO — Landrr.js"
      description="Meta tags and SEO with the Head component."
    >
      <h1>SEO</h1>
      <p>Use the <code>Head</code> component from <code>@landrr/core</code>:</p>
      <pre>
        <code>{`import { Head } from "@landrr/core";

export default function Page() {
  return (
    <>
      <Head
        title="My page"
        description="Page description"
        ogType="website"
        twitterCard="summary_large_image"
      />
      <h1>Content</h1>
    </>
  );
}`}</code>
      </pre>
      <p>
        Tags are collected during SSR and injected into
        <code> &lt;!--head-tags--&gt;</code> in <code>index.html</code>.
      </p>
    </DocPage>
  );
}
